import fetch from 'api/fetch'

export function getGrouponRecomendReq({ spuId, skuId, promotionId }) {
  return fetch({
    url: '/groupon/detail/recommend',
    params: {
      spuId,
      skuId,
      promotionId
    }
  })
}
